export default __webpack_public_path__ + "static/media/6.6bc64004.png";